function processCvcManual(container) {
  container.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(node.textContent, 'text/html');

      const frag = document.createDocumentFragment();
      while (doc.body.firstChild) {
        frag.appendChild(doc.body.firstChild);
      }

      node.replaceWith(frag);
    }
  });
}

// Xử lý các phần tử đã có sẵn
document.querySelectorAll('.cvc-manual').forEach(processCvcManual);

// Theo dõi DOM
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;

      if (node.matches?.('.cvc-manual')) {
        processCvcManual(node);
      }

      node.querySelectorAll?.('.cvc-manual').forEach(processCvcManual);
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});